import { Outlet, useNavigation } from "react-router";

export function RootLayout() {
  // Data-mode navigation keeps the current page on screen until every loader for
  // the next one resolves, so without this the app looks frozen between the
  // click and the switch — the whole delay reads as lag.
  const loading = useNavigation().state === "loading";
  return (
    <>
      <div className="dt-progress" data-active={loading || undefined} aria-hidden="true">
        <span className="dt-progress__bar" />
      </div>
      <Outlet />
    </>
  );
}
